import {useEffect, useState} from 'react';

const useProgressReveal = (ratio: number) => {
    const [revealedRatio, setRevealedRatio] = useState(0);

    useEffect(() => {
        let secondFrame = 0;
        const firstFrame = requestAnimationFrame(() => {
            secondFrame = requestAnimationFrame(() => setRevealedRatio(ratio));
        });

        return () => {
            cancelAnimationFrame(firstFrame);
            cancelAnimationFrame(secondFrame);
        };
    }, [ratio]);

    return revealedRatio;
};

export default useProgressReveal;
